import axios from "axios";

export const BASE_URL = "https://csicloudapi.csidealer.com/api/";
//export const BASE_URL = "http://52.168.95.49:81/api/";

const instance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("token"),
  },
});

export default instance;
